import React from 'react';
import Profissional from '../../../components/Profissionais/Profissionais';
import MarliImg from '../../../assets/profissionais/miranda.png';

function Marli() {
  return (
    <Profissional 
      nome="Marli Fonseca Miranda"
      customClass="profissional-marli"
      cargo="Orientadora Familiar"
      imagem={MarliImg}
      descricao={
        <>
          <div className="profissional-descricao">
            <p>Atuo há 41 anos na educação. Atuei como professora de educação infantil (Maternal I ao Pré-Primário); alfabetizadora; como professora de Arte e Ensino Religioso nos anos finais do Ensino Fundamental. Há 20 anos atuo como coordenadora pedagógica da Educação Infantil e séries iniciais, até a presente data.</p>

            <p>Possuo Magistério das séries iniciais, Bacharel em Teologia, Graduada em Pedagogia, Especializada em Educação Infantil, Pós-Graduada em Educação Infantil e séries Iniciais e Psicopedagoga Clínica e Institucional, Professora de Pós-Graduação no Curso de Alfabetização e Letramento (Faculdade Estácio de Sá/Polo Colégio Educador), Supervisora Pedagógica na Educação Profissional (Senac), Pós em Neurociências aplicada à educação (cursando).</p><br></br>

            <p>Na Família Singular, atuarei na orientação às famílias, uma vez que o diagnóstico causa um certo desconforto, negação e sensação de impotência. </p>

            <p>Sabemos que cada criança é única, e as abordagens que funcionam para uma podem não ser eficazes para outra e para isso queremos que haja a redução do estresse e da ansiedade, para que a criança desenvolva habilidades de autocuidado e independência.</p>
          </div>
        </>
      }
    />
  );
}

export default Marli;
